import Cookies from "js-cookie";
import CryptoJS from "crypto-js";

const SECRET =
  import.meta.env.VITE_SECRET_KEY || "netlos_default_secret_32char!";

const encrypt = (plain: string): string => {
  return CryptoJS.AES.encrypt(plain, SECRET).toString();
};

const decrypt = (cipher: string): string => {
  try {
    return CryptoJS.AES.decrypt(cipher, SECRET).toString(CryptoJS.enc.Utf8);
  } catch {
    return "";
  }
};

export const setTokens = (access: string, refresh: string) => {
  // Use secure cookies only on HTTPS to support local dev/tests in http/jsdom
  const isHttps =
    typeof window !== "undefined" && window.location?.protocol === "https:";
  Cookies.set("at", encrypt(access), {
    secure: isHttps,
    sameSite: "strict",
    path: "/",
  });
  Cookies.set("rt", encrypt(refresh), {
    secure: isHttps,
    sameSite: "strict",
    path: "/",
  });
};

export const getTokens = () => {
  const at = Cookies.get("at");
  const rt = Cookies.get("rt");
  return {
    access: at ? decrypt(at) : null,
    refresh: rt ? decrypt(rt) : null,
  };
};

export const clearTokens = () => {
  Cookies.remove("at", { path: "/" });
  Cookies.remove("rt", { path: "/" });
};
